import { ChartingItemType } from '@caresend/types';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$1 from './ChartingItemCard.vue.js';
import { usePortalStore } from '../portal/store/portal/index.js';
import TransitionExpand from '../../transitions/TransitionExpand/TransitionExpand.js';

var script = defineComponent({
    name: 'ChartingItemGroup',
    components: {
        BasicCard: __vue_component__,
        ChartingItemCard: __vue_component__$1,
        TransitionExpand,
    },
    props: {
        /**
         * An array of indices to support charting items nested in groups.
         * Example: [1, 2] - Root ChartingItem of index 1, nested non-group
         * ChartingItem of index 2.
         */
        indexArray: {
            type: Array,
            required: true,
        },
        procedureID: {
            type: String,
            required: true,
        },
        highlight: Boolean,
        /**
         * A map of charting item ids to a boolean indicating if the item should be shown conditionally.
         *
         * Now get from parent so we don't have to compute twice
         */
        conditionalFollowUpDisplayMap: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { procedures } = usePortalStore();
        const item = computed(() => procedures.getters.chartingItemByIndexArray(props.procedureID, props.indexArray));
        const isGroup = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.GROUP; });
        /**
         * Returns true if the item should be shown conditionally based off of the
         * conditional follow up display map.
         */
        const shouldShowMaybeConditionalItem = ({ id }) => !id
            || props.conditionalFollowUpDisplayMap[id] === undefined
            || !!props.conditionalFollowUpDisplayMap[id];
        return {
            isGroup,
            item,
            shouldShowMaybeConditionalItem,
        };
    },
});

export { script as default };
